import { Tag } from 'antd';
import { type ColumnType } from 'antd/lib/table/interface';
import React from 'react';

import type DocumentFolder from 'stores/DocumentFolder';

import StarSwitch from '../StarSwitch/StarSwitch';
import Table from '../Table/Table';
import { makeStringSorter, makeTimestampSorter } from 'utils/TableUtils';
import { formatDateTimeMedSeconds } from 'utils/Dates';

function getTableColumns(): Array<ColumnType<DocumentFolder>> {
  return [
    {
      title: 'Starred',
      render: (_value, record) => <StarSwitch store={record} />,
      width: 32
    },

    {
      title: 'Name',
      render: (_value, record) => record.data.name,
      width: '15%',
      sorter: makeStringSorter((r) => r.data.name)
    },

    {
      title: 'Tags',
      render: (_value, record) =>
        (record.data.tags || []).map((tag: string) => (
          <Tag key={`tag.${tag}`}>{tag}</Tag>
        ))
    },

    {
      title: 'Modified',
      defaultSortOrder: 'descend',
      render: (row) => formatDateTimeMedSeconds(row.data?.dateModified),
      width: '25%',
      sorter: makeTimestampSorter((r) => r.data.dateModified)
    }
  ];
}

export interface StarredTableProps {
  items: DocumentFolder<any, any>[];
  onItemClick?: (item: DocumentFolder) => void;
  title: string;
}

function StarredTable({ items, onItemClick, title }: StarredTableProps) {
  return (
    <Table
      columnsDefinition={getTableColumns()}
      data={items}
      headerButtons={[]}
      onRowClick={(record) => onItemClick?.(record)}
      onRowMiddleClick={(record) => window.open(record.url, '_blank')}
      title={title}
    />
  );
}

export default StarredTable;
